﻿import React, { useState, useEffect } from 'react';
import { BenchSheetTechnologyType, DocumentType, NoteType, Entities } from '../../models/enums';
import { ProductBatchListItem } from '../../models/product-batch-list-item';
import BenchSheetToolbar from '../BenchSheetToolbar';
import BatchSearch from '../BatchSearch';
import { CoaReport } from '../../models/Coa/coa-report';
import { CrudFunctions } from '../../utilities/crud-functions';
import GlobalDialog from '../Modal/GlobalDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';

import DataGrid, {
    Column,
    Button as ColumnButton,
    Paging,
    Editing,
    Lookup,
    LoadPanel,
    Scrolling,
    Selection,
    Toolbar,
    Item as ToolbarItem
} from 'devextreme-react/data-grid';

import { Popup as DialogPopup } from 'devextreme-react/popup';
import TextBox from 'devextreme-react/text-box';
import Button from 'devextreme-react/button';

import Editor, { DiffEditor, useMonaco, loader } from '@monaco-editor/react';

let key = 1;

export default function CoaTools() {
    const [selectedBatch, setSelectedBatch] =
        useState<ProductBatchListItem>();

    const [coaReports, setCoaReports] =
        useState<CoaReport[]>();

    const [selectedCoaReport, setSelectedCoaReport] =
        useState<CoaReport>();

    const [selectedReportRepxXml, setSelectedReportRepxXml] =
        useState<string>();

    const [batchSearchVisible, setBatchSearchVisible] =
        useState<boolean>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, []);

    key++;
    const gridWidth = 'calc(90vw - 13em)';

    const selectedBatchName = () => {
        if (selectedBatch)
            return `${selectedBatch.batchName}.${selectedBatch.batchVersionString} (${selectedBatch.batchTypeString})`;

        return "";
    }

    return (
        <div className="pw-form-container">
            <div className="lq-title-bar">
                <BenchSheetToolbar title="COA Tools" entity={Entities.CoaTools}
                    subtitle="Certificates of Analysis Tools" />
            </div>

            <div className="pw-comp-row">
                <Button id="toggleBatchSearchButton" text="Search Batches" icon="search" type="success"
                    hint="search batches"
                    height='2.6em'
                    onClick={showBatchSearchDialog} />

                <div className="pw-form-unit pw-comp-10">
                    <div className="pw-form-unit-label">Catalog #</div>
                    <div className="pw-readonly-label">{selectedBatch ? selectedBatch.catalogNumber : ''}</div>
                </div>

                <div className="pw-form-unit">
                    <div className="pw-form-unit-label">Batch</div>
                    <div className="pw-readonly-label">{selectedBatchName()}</div>
                </div>
            </div>

            <div className='pw-comp-row pw-margin-top-1'>
                <DataGrid
                    height="16rem"
                    width={gridWidth}
                    keyExpr="reportId"
                    dataSource={coaReports ? coaReports : []}
                    onSelectionChanged={onCoaReportTemplatesSelectionChanged}
                    wordWrapEnabled={true}
                    showRowLines={true}
                    rowAlternationEnabled={true}
                    showBorders={true} >

                    <Selection mode={'single'} />
                    <Paging enabled={false} />

                    <Column type="buttons" width='6rem' >
                        <ColumnButton hint="information" icon="codeblock"
                            onClick={onGetReportRepxXmlClick} />
                    </Column>

                    <Column dataField='reportId' width='10rem' dataType="string" />
                    <Column dataField='name' width='15rem' dataType="string" />
                    <Column dataField='description' width='26rem' dataType="string" />
                    <Column dataField='createTimestamp' width='10rem' dataType="date" />
                    <Column dataField='modifyTimestamp' width='10rem' dataType="date" />
                    <Column />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Report Templates</div>
                            </div>
                        </ToolbarItem>
                    </Toolbar>

                </DataGrid>
            </div>

            <div className='pw-comp-row pw-margin-top-1'>
                <Button type='success' text='Run Report' icon="pdffile"
                    height='2.6em'
                    onClick={onRunReportClick} />
            </div>

            <div className='pw-margin-top-1'>
                <div className="lq-main-title">Report Configuration (.repx)</div>
            </div>

            <div className='pw-margin-top-1'>
                <Editor height="50rem" defaultLanguage='xml' value={selectedReportRepxXml ? selectedReportRepxXml : ""} defaultValue="" />
            </div>

            {batchSearchVisible &&
                <DialogPopup key={`ciSearch${key}`}
                    visible={batchSearchVisible}
                    onHiding={hideBatchSearchDialog}
                    hideOnOutsideClick={true}
                    dragEnabled={true}
                    resizeEnabled={false}
                    title="Batches Search"
                    width='45rem'
                    height='40rem'>
                    <BatchSearch
                        onCancel={hideBatchSearchDialog}
                        onSubmit={applySelectedBatch} />
                </DialogPopup>
            }

        </div>
    );

    function onCoaReportTemplatesSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            setSelectedCoaReport(e.selectedRowsData[0]);
        }
    }

    function onGetReportRepxXmlClick(e: any) {
        console.log("onGetReportRepxXmlClick");
        console.log(e);

        if(e.row && e.row.data && e.row.data.reportId)
            getReportXml(e.row.data.reportId);
    }

    function applySelectedBatch(batch: ProductBatchListItem) {
        setSelectedBatch(batch);
        hideBatchSearchDialog();
    }

    async function onRunReportClick() {
        if (selectedBatch) {
            await CrudFunctions.getDataBlob(`coatools/generatereport/${selectedBatch.batchId}`)
                .then((blob: any) => {
                    let a = document.createElement("a") as HTMLAnchorElement;

                    document.body.appendChild(a);
                    a.style.display = "none";

                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    //todo:
                    a.download = `COA-${selectedBatch.batchName}.pdf`;
                    a.click();
                    window.URL.revokeObjectURL(url);

                    //to open PDF in browser:
                    // let file = window.URL.createObjectURL(blob);
                    // window.open(file, "_blank");
                });
        }
    }

    async function getReportTemplates() {
        await CrudFunctions.getData("coatools/coareports")
            .then((data) => {
                setCoaReports(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Uploading COA Report Templates");
            });
    }

    async function getReportXml(reportId: string) {
        await CrudFunctions.getData(`coatools/coareportxmlbyreportid/${reportId}`)
            .then((data) => {
                console.log(data);

                if (data && data.value)
                    setSelectedReportRepxXml(data.value);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Uploading COA Report Templates");
            });
    }

    async function getAllData() {
        await Promise.all([
            getReportTemplates()
        ])
    }

    function showBatchSearchDialog() {
        setBatchSearchVisible(true);
    }

    function hideBatchSearchDialog() {
        setBatchSearchVisible(false);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}

